<template>
  <div>
    <carousel
      class="card__wrapper"
      :items-to-show="1"
      v-if="contactsLocal.length > 0"
      ref="myCarousel"
      v-model="currentIndex"
      :dir="language.dir"
      :wrapAround="true"
    >
      <slide v-for="(item, slide) in contactsLocal" :key="slide">
        <local-contact
          :contact="item"
          @reload="getData"
          @DeleteContact="DeleteContact"
        ></local-contact>
      </slide>
      <template #addons="{ slidesCount }">
        <navigation v-if="slidesCount > 1" />
      </template>
    </carousel>
    <div class="p-d-flex p-jc-end" style="gap: 10px;">
      <p-vue-button
        icon="pi pi-pencil"
        class="p-button-rounded p-button-success p-button-outlined"
        @click="addOrUpdate(contactsLocal[currentIndex])"
      />
      <p-vue-button
        icon="pi pi-trash"
        class="p-button-rounded p-button-danger p-button-outlined"
        :disabled="contactsLocal[currentIndex]?.IsMain"
        @click="confirmDelete"
      />
      <p-vue-button
        icon="pi pi-plus"
        class="p-button-rounded p-button-success p-button-outlined"
        @click="addOrUpdate({ SupplierSubID: contactsLocal[0].SupplierSubID })"
      />
    </div>
  </div>
  <i-override-dialog
    v-model:visible="showModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="__('update') + ' ' + __('Supplier')"
  >
    <local-add-supplier
      :supplier="ContactUpdate"
      :updateContact="true"
      :close="
        () => {
          showModal = false;
        }
      "
      @supplierUpdate="supplierUpdate"
      v-if="editMain"
    ></local-add-supplier>
    <local-add-contact
      v-else
      :close="
        () => {
          showModal = false;
        }
      "
      :contact="contactToUpdate"
      @ContactUpdate="ContactUpdate"
    ></local-add-contact>
  </i-override-dialog>
</template>

<script>
import LocalContact from "./contact";
import LocalAddContact from "./add-contact";
import LocalAddSupplier from "../add-supplier";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { __ } from "@/plugins/i18n/";
import "vue3-carousel/dist/carousel.css";
import { mapState } from "vuex";
export default {
  components: {
    Carousel,
    Slide,
    Navigation,
    LocalContact,
    LocalAddContact,
    LocalAddSupplier,
  },
  props: {
    contacts: [],
  },
  data() {
    return {
      currentIndex: 0,
      contactsLocal: [],
      showModal: false,
      editMain: false,
      contactToUpdate: {},
    };
  },
  mounted() {
    this.contactsLocal = this.contacts;
  },
  methods: {
    confirmDelete(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: __("Are you sure?"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.changeItemKey("Delete");
        },
        reject: () => {},
      });
    },
    changeItemKey(key) {
      this.contactsLocal[this.currentIndex][key] = true;
    },
    DeleteContact(id) {
      let index = this.contacts.findIndex((f) => f.id == id);
      this.contactsLocal.splice(index, 1);
    },
    addOrUpdate(contact) {
      if (contact.IsMain) this.editMain = true;
      else this.editMain = false;
      this.contactToUpdate = contact;
      this.showModal = true;
    },
    ContactUpdate(contact) {
      let index = this.contactsLocal.findIndex((f) => f.id == contact.id);
      if (index != -1) this.contactsLocal[index] = contact;
      else this.contactsLocal.push(contact);
      this.showModal = false;
      this.currentIndex = index == -1 ? this.contactsLocal.length - 1 : index;
    },
    supplierUpdate(x) {
      console.log(x);
    },
  },
  computed: {
    ...mapState({
      language: (state) => state.local,
    }),
  },
};
</script>

<style scoped>
:deep(.carousel__slide) {
  display: block;
}

.card__wrapper {
  text-align: right;
  /* direction: rtl; */
}

:deep(.carousel__prev),
:deep(.carousel__next) {
  background-color: #fff;
  border: 1px solid var(--color-success);
}

:deep(.carousel__icon) {
  fill: var(--color-success);
}
</style>
